import { HeaderButtons } from "./HeaderButtons";
import { HeaderTitle } from "./HeaderTitle";
import { HeaderContainer } from "./HeaderContainer";
import { AnimeSelectorContainer } from "./AnimeSelectorContainer";
import { BroadcastSelectorContainer } from "./BroadcastSelectorContainer";
import { SelectorsContainer } from "./SelectorsContainer";
import { AnnouncementButton } from "./AnnouncementButton";
import { AnimeItems } from "./AnimeItems";
import { BroadcastItems } from "./BroadcastItems";

const style = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#E0E0E0",
  borderRadius: 12,
  outline: "solid 1px #C0C0C0",
  margin: 80,
  height: 448
};

export function ItemSelector() {
  return (<>
    <div style={ style }>
      <SelectorsContainer>
        <AnimeSelectorContainer>
          <HeaderContainer rounding="left">
            <HeaderTitle text="애니메이션"/>
            <HeaderButtons type="anime"/>
          </HeaderContainer>
          <AnimeItems/>
        </AnimeSelectorContainer>
        <BroadcastSelectorContainer>
          <HeaderContainer rounding="right">
            <HeaderTitle text="방송"/>
            <HeaderButtons type="broadcast"/>
          </HeaderContainer>
          <BroadcastItems/>
        </BroadcastSelectorContainer>
      </SelectorsContainer>
      <AnnouncementButton/>
    </div>
  </>);
}
